var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "pdfTemple",
      staticClass: "pdfTemple",
      staticStyle: {
        position: "absolute",
        bottom: "-999px",
        width: "1920px",
        padding: "20px",
      },
    },
    [
      _vm.data.innerOrderSn
        ? _c("div", { staticClass: "invoice-box" }, [
            _c(
              "table",
              { attrs: { cellpadding: "0", cellspacing: "0" } },
              [
                _c("tr", { staticClass: "top" }, [
                  _c("td", { attrs: { colspan: "5" } }, [
                    _c("table", [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "title",
                            staticStyle: { width: "50%" },
                          },
                          [
                            _c("b", [_vm._v("DELIVERY NOTE")]),
                            _c("p", [
                              _vm._v(
                                "Order ID: #" + _vm._s(_vm.data.innerOrderSn)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "Sales Order Number: " +
                                  _vm._s(_vm.data.orderSn)
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("tr", { staticClass: "information" }, [
                  _c("td", { attrs: { colspan: "5" } }, [
                    _c("table", [
                      _c("tr", [
                        _vm._m(0),
                        _c("td", [
                          _vm._v(
                            " Ship To: " +
                              _vm._s(_vm.data.receiverAddress) +
                              ", " +
                              _vm._s(_vm.data.receiverAddress2) +
                              "."
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(_vm.data.receiverCity) +
                              ", " +
                              _vm._s(_vm.data.receiverProvince)
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(_vm.data.receiverCountry) +
                              " - " +
                              _vm._s(_vm.data.receiverPostcode)
                          ),
                          _c("br"),
                          _vm._v(" " + _vm._s(_vm.data.receiverName)),
                          _c("br"),
                          _vm._v(" " + _vm._s(_vm.data.receiverMobile)),
                          _c("br"),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._m(1),
                _vm._l(_vm.data.skuDTOList, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(item.skuCode))]),
                    _c("td", [_vm._v(_vm._s(item.skuName))]),
                    _c("td", [_vm._v(_vm._s(item.number))]),
                  ])
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "50%" } }, [
      _vm._v(" From: 62 Goodall Close, Dandenong South "),
      _c("br"),
      _vm._v(" VIC 3175, Australia Phone: 0391176197 "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "heading" }, [
      _c("td", [_vm._v("SKU")]),
      _c("td", { staticStyle: { "text-align": "right" } }, [_vm._v("Name")]),
      _c("td", { staticStyle: { "text-align": "right" } }, [_vm._v("Qty")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }